import React from "react";

import { CatalogueDef, CatalogueId } from "./types";

type CatalogueSidebarProps = {
  catalogues: CatalogueDef[];
  catalogueId: CatalogueId;
  onChange: (catalogueId: CatalogueId) => void;
};

export const CatalogueSidebar = ({ catalogues, catalogueId, onChange }: CatalogueSidebarProps) => {
  return (
    <aside
      style={{
        border: "1px solid #D2D2D2",
        background: "#fff",
        borderRadius: "8px 8px 0 0",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "16px",
          fontSize: 16,
          fontWeight: "normal",
          color: "#fff",
          backgroundColor: "#184461",
        }}
      >
        MODULES
      </div>
      {catalogues.map((item) => {
        const active = item.id === catalogueId;

        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onChange(item.id)}
            style={{
              width: "100%",
              display: "block",
              padding: "16px",
              border: "none",
              borderBottom: "1px solid #D2D2D2",
              borderLeft: active ? "3px solid #184461" : "3px solid transparent",
              cursor: "pointer",
              textAlign: "left",
              background: active ? "#E2E7F6" : "#fff",
              color: active ? "#184461" : "rgba(0, 0, 0, 0.85)",
              fontSize: 14,
              fontWeight: active ? 600 : "normal",
              lineHeight: 1.5715,
            }}
          >
            {item.title}
          </button>
        );
      })}
    </aside>
  );
};
